export default __webpack_public_path__ + "images/projects/true-memoirs-of-an-international-assassin/true-memoirs-of-an-international-assassin-poster.jpg";